import { takeUntil } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { OrganisationUserService } from '@organisations/services/organisation-user/organisation-user.service';

import { MenuComponent } from '../menu/menu.component';

@Component({
	selector: 'app-mobile-header',
	imports: [CommonModule, MenuComponent, RouterLink],
	templateUrl: './mobile-header.component.html',
	styleUrl: './mobile-header.component.scss',
})
export class MobileHeaderComponent implements OnInit, OnDestroy {
	private organisationUserService = inject(OrganisationUserService);
	destroyed$ = new EventEmitter<void>();
	hasNotification: boolean = false;

	ngOnInit(): void {
		this.organisationUserService.userHasOrganisationInvitations$.pipe(takeUntil(this.destroyed$)).subscribe((hasInvitations) => {
			this.hasNotification = hasInvitations;
		});
	}

	ngOnDestroy(): void {
		this.destroyed$.emit();
	}
}
